/**
 * Do not edit directly
 * Generated on Fri, 04 Apr 2025 23:07:11 GMT
 */

export const edsColorSev1 = "#1EAA52";
export const edsColorSev2 = "#1151FF";
export const edsColorSev3 = "#FCA600";
export const edsColorSev4 = "#EE0005";
export const edsColorCat1 = "#300080";
export const edsColorCat2 = "#0034E3";
export const edsColorCat3 = "#1190FF";
export const edsColorCat4 = "#007D48";
export const edsColorCat5 = "#1EAA52";
export const edsColorCat6 = "#FCA600";
export const edsColorCat7 = "#FF5000";
export const edsColorCat8 = "#A50767";
export const edsColorCatDurant1 = "#008E98";
export const edsColorCatDurant2 = "#FF5000";
export const edsColorCatDurant3 = "#FCA600";
export const edsColorCatDurant4 = "#ED1AA0";
export const edsColorCatDurant5 = "#6E0FF6";
export const edsColorCatDurant6 = "#8755FF";
export const edsColorCatDurant7 = "#1190FF";
export const edsColorCatDurant8 = "#4CABFF";
export const edsColorCatWhynot1 = "#020664";
export const edsColorCatWhynot2 = "#1151FF";
export const edsColorCatWhynot3 = "#D00B84";
export const edsColorCatWhynot4 = "#ED1AA0";
export const edsColorCatWhynot5 = "#F08E0A";
export const edsColorCatWhynot6 = "#6E0FF6";
export const edsColorCatWhynot7 = "#008E98";
export const edsColorCatWhynot8 = "#005C68";
export const edsColorCatOneonta1 = "#4400A9";
export const edsColorCatOneonta2 = "#4CABFF";
export const edsColorCatOneonta3 = "#EE0005";
export const edsColorCatOneonta4 = "#FF7975";
export const edsColorCatOneonta5 = "#BEAFFD";
export const edsColorCatOneonta6 = "#8755FF";
export const edsColorCatOneonta7 = "#1EAA52";
export const edsColorCatOneonta8 = "#FFA584";
export const edsColorSeqBlue1 = "#020664";
export const edsColorSeqBlue2 = "#02068E";
export const edsColorSeqBlue3 = "#061DBB";
export const edsColorSeqBlue4 = "#0034E3";
export const edsColorSeqBlue5 = "#1151FF";
export const edsColorSeqBlue6 = "#1190FF";
export const edsColorSeqBlue7 = "#4CABFF";
export const edsColorSeqBlue8 = "#87CEFF";
export const edsColorBlack = "#111111";
export const edsColorGrey1 = "#707072";
export const edsColorGrey2 = "#CACACB";
export const edsColorGrey3 = "#E5E5E5";
export const edsColorGrey4 = "#F5F5F5";
export const edsColorGrey5 = "#FAFAFA";
export const edsColorGrey6 = "#F5F5F5";
export const edsColorGrey7 = "#6A6A6A";
export const edsColorGrey1OnDark = "#CACACB";
export const edsColorGrey2OnDark = "#9E9EA0";
export const edsColorGrey3OnDark = "#707072";
export const edsColorGrey4OnDark = "#39393B";
export const edsColorGrey5OnDark = "#28282A";
export const edsColorGrey6OnDark = "#28282A";
export const edsColorGrey7OnDark = "#6A6A6A";
export const edsColorWhite = "#FFFFFF";
export const edsColorRed100 = "#3D1F17";
export const edsColorRed90 = "#530300";
export const edsColorRed80 = "#780700";
export const edsColorRed70 = "#A70E00";
export const edsColorRed60 = "#D30005";
export const edsColorRed50 = "#EE0005";
export const edsColorRed40 = "#FF4E4A";
export const edsColorRed30 = "#FF7975";
export const edsColorRed20 = "#FFABAD";
export const edsColorRed10 = "#FFC3C4";
export const edsColorRed05 = "#FFE5E5";
export const edsColorOrange100 = "#382113";
export const edsColorOrange90 = "#3E1009";
export const edsColorOrange80 = "#5D180C";
export const edsColorOrange70 = "#7E200D";
export const edsColorOrange60 = "#9F290F";
export const edsColorOrange50 = "#D33918";
export const edsColorOrange40 = "#FF5000";
export const edsColorOrange30 = "#FF8255";
export const edsColorOrange20 = "#FFA584";
export const edsColorOrange10 = "#FFC5AD";
export const edsColorOrange05 = "#FFE2D6";
export const edsColorYellow100 = "#332412";
export const edsColorYellow90 = "#99470A";
export const edsColorYellow80 = "#CD6006";
export const edsColorYellow70 = "#E57A09";
export const edsColorYellow60 = "#F08E0A";
export const edsColorYellow50 = "#FCA600";
export const edsColorYellow40 = "#FDC400";
export const edsColorYellow30 = "#FFD11B";
export const edsColorYellow20 = "#FEDF35";
export const edsColorYellow10 = "#FEEA55";
export const edsColorYellow05 = "#FEF087";
export const edsColorGreen100 = "#1A2B16";
export const edsColorGreen90 = "#003C2A";
export const edsColorGreen80 = "#005034";
export const edsColorGreen70 = "#00643E";
export const edsColorGreen60 = "#007D48";
export const edsColorGreen50 = "#1EAA52";
export const edsColorGreen40 = "#3CCD49";
export const edsColorGreen30 = "#5FE63F";
export const edsColorGreen20 = "#83F13B";
export const edsColorGreen10 = "#BDFB72";
export const edsColorGreen05 = "#DFFFB9";
export const edsColorTeal100 = "#1A292C";
export const edsColorTeal90 = "#043441";
export const edsColorTeal80 = "#004856";
export const edsColorTeal70 = "#005C68";
export const edsColorTeal60 = "#0A7281";
export const edsColorTeal50 = "#008E98";
export const edsColorTeal40 = "#1CB2B6";
export const edsColorTeal30 = "#31CBCB";
export const edsColorTeal20 = "#69EEE7";
export const edsColorTeal10 = "#9CFFF7";
export const edsColorTeal05 = "#D4FFFB";
export const edsColorBlue100 = "#1C273C";
export const edsColorBlue90 = "#020664";
export const edsColorBlue80 = "#02068E";
export const edsColorBlue70 = "#061DBB";
export const edsColorBlue60 = "#0034E3";
export const edsColorBlue50 = "#1151FF";
export const edsColorBlue40 = "#1190FF";
export const edsColorBlue30 = "#4CABFF";
export const edsColorBlue20 = "#87CEFF";
export const edsColorBlue10 = "#B9E2FF";
export const edsColorBlue05 = "#D6EEFF";
export const edsColorIndigo100 = "#272342";
export const edsColorIndigo90 = "#2E2A53";
export const edsColorIndigo80 = "#3A3675";
export const edsColorIndigo70 = "#48439F";
export const edsColorIndigo60 = "#5451C8";
export const edsColorIndigo50 = "#6A64DF";
export const edsColorIndigo40 = "#837BED";
export const edsColorIndigo30 = "#9F95FD";
export const edsColorIndigo20 = "#BBB1FF";
export const edsColorIndigo10 = "#D2CAFF";
export const edsColorIndigo05 = "#F0EDFF";
export const edsColorPurple100 = "#312038";
export const edsColorPurple90 = "#1C0060";
export const edsColorPurple80 = "#300080";
export const edsColorPurple70 = "#4400A9";
export const edsColorPurple60 = "#5400CC";
export const edsColorPurple50 = "#6E0FF6";
export const edsColorPurple40 = "#8755FF";
export const edsColorPurple30 = "#A082FF";
export const edsColorPurple20 = "#BEAFFD";
export const edsColorPurple10 = "#D6D1FF";
export const edsColorPurple05 = "#E4E1FC";
export const edsColorPink100 = "#3E1E1E";
export const edsColorPink90 = "#4C012D";
export const edsColorPink80 = "#770349";
export const edsColorPink70 = "#A50767";
export const edsColorPink60 = "#D00B84";
export const edsColorPink50 = "#ED1AA0";
export const edsColorPink40 = "#FC5DBB";
export const edsColorPink30 = "#FE90CC";
export const edsColorPink20 = "#FFB0DD";
export const edsColorPink10 = "#FFCDEA";
export const edsColorPink05 = "#FFE1F3";
export const edsColorTextSuccess = "#007D48";
export const edsColorTextDanger = "#D30005";
export const edsColorTextWarning = "#111111";
export const edsColorTextDefault = "#111111";
export const edsColorTextSecondary = "#707072";
export const edsColorTextHover = "#707072";
export const edsColorTextLink = "#1151FF";
export const edsColorTextLinkVisited = "#5400CC";
export const edsColorTextLinkDisable = "#CACACB";
export const edsColorBackgroundSuccess = "#007D48";
export const edsColorBackgroundDanger = "#D30005";
export const edsColorBackgroundWarning = "#FEDF35";
export const edsColorBackgroundDefault = "#FFFFFF";
export const edsColorBackgroundSecondary = "#F5F5F5";
export const edsColorBackgroundDisabled = "#E5E5E5";
export const edsColorBackgroundHover = "#FAFAFA";
export const edsColorBackgroundActive = "#F5F5F5";
export const edsColorBorderPrimary = "#707072";
export const edsColorBorderDisabled = "#E5E5E5";
export const edsColorBorderSuccess = "#007D48";
export const edsColorBorderDanger = "#D30005";
export const edsColorBorderWarning = "#111111";
export const edsColorBorderHover = "#707072";
export const edsColorBorderActive = "#111111";
export const edsColorBorderFocus = "#0034E3";
export const edsColorBrandRed = "#EE0005";
export const edsColorBrandOrange = "#FE5000";
export const edsColorBrandGradient = "linear-gradient(113.7deg, #FF0015 3.64%, #fe5000 50.92%, #FF6A00 97.26%)";
export const edsElevationShadow1 = " 0px 1px 2px rgba(17, 17, 17, 0.04), 0px 2px 6px rgba(17, 17, 17, 0.08)";
export const edsElevationShadow2 = " 0px 2px 3px rgba(17, 17, 17, 0.04), 0px 4px 12px rgba(17, 17, 17, 0.08)";
export const edsElevationShadow3 = " 0px 4px 8px rgba(17, 17, 17, 0.04), 0px 8px 24px rgba(17, 17, 17, 0.08)";
export const edsElevationShadow4 = " 0px 8px 16px rgba(17, 17, 17, 0.04), 0px 16px 48px rgba(17, 17, 17, 0.08)";
export const edsRadii0 = "0px";
export const edsRadii4 = "4px";
export const edsRadii8 = "8px";
export const edsRadiiRounded = "9999px";
export const edsSpace4 = "4px";
export const edsSpace8 = "8px";
export const edsSpace12 = "12px";
export const edsSpace16 = "16px";
export const edsSpace24 = "24px";
export const edsSpace32 = "32px";
export const edsSpace40 = "40px";
export const edsSpace48 = "48px";
export const edsSpace56 = "56px";
export const edsSpace72 = "72px";
export const edsSpace96 = "96px";
export const edsTypeHelveticaNeue = "\"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeNikeFutura = "\"Nike Futura\",\"Helvetica Neue\",Helvetica,Arial,sans-serif";
export const edsTypeDisplay1 = "normal normal 700 72px/62px \"Nike Futura\",\"Helvetica Neue\",Helvetica,Arial,sans-serif";
export const edsTypeDisplay2 = "normal normal 700 56px/48px \"Nike Futura\",\"Helvetica Neue\",Helvetica,Arial,sans-serif";
export const edsTypeDisplay3 = "normal normal 700 48px/40px \"Nike Futura\",\"Helvetica Neue\",Helvetica,Arial,sans-serif";
export const edsTypeDisplay4 = "normal normal 700 40px/34px \"Nike Futura\",\"Helvetica Neue\",Helvetica,Arial,sans-serif";
export const edsTypeDisplay5 = "normal normal 700 24px/22px \"Nike Futura\",\"Helvetica Neue\",Helvetica,Arial,sans-serif";
export const edsTypeTitle1 = "normal normal 500 36px/40px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeTitle2 = "normal normal 500 32px/36px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeTitle3 = "normal normal 500 28px/32px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeTitle4 = "normal normal 500 24px/28px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeTitle5 = "normal normal 500 20px/24px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeTitle6 = "normal normal 500 18px/24px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeSubtitle1 = "normal normal 500 16px/24px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeSubtitle2 = "normal normal 500 14px/20px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeBody1 = "normal normal 400 20px/28px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeBody2 = "normal normal 400 16px/24px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeBody3 = "normal normal 400 14px/20px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsTypeLegal1 = "normal normal 400 12px/18px \"Helvetica Neue\", Helvetica, Arial, sans-serif";
export const edsLayers10 = 10;
export const edsLayers20 = 20;
export const edsLayers30 = 30;
export const edsLayers40 = 40;
export const edsLayers50 = 50;
export const edsLayers60 = 60;
